<template>
  <div>

    <div class="columns is-multiline">

      <div class="column is-12">
        <div class="field">
          <label class="label">Import</label>
          <div class="file">
            <label class="file-label">
              <input class="file-input" type="file" ref="inputFile" @change="updateLabel()">
              <span class="file-cta">
                <span class="file-icon">
                  <font-awesome-icon icon="upload" />
                </span>
                <span class="file-label">
                  {{ importLabel }}
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>

      <div class="column is-12">
        <button class="button is-primary" :class="[{'is-loading': disabledSave}]" :disabled="disabledSave || !($refs.inputFile && $refs.inputFile.files)" @click="startUpload()"><font-awesome-icon icon="magnifying-glass" />Esamina</button>
      </div>

      <div class="column is-12">
        <b>Impianti trovati: {{ implants.found }}</b>
      </div>

      <div class="column is-12">
        <div class="is-flex is-align-items-center">
          <b>Impianti nuovi da file: {{ implants.new ? implants.new.length : 0 }}</b>
          <button class="button is-dark ml-2" @click="showNew = !showNew"><font-awesome-icon :icon="showNew ? 'eye-slash' : 'eye'" /> {{ showNew ? 'Chiudi' : 'Apri' }}</button>
        </div>
        <table v-if="implants.new && implants.new.length" class="table is-fullwidth" v-show="showNew">
          <thead>
            <tr>
              <td>Codice</td>
              <td>Targa</td>
              <td>POD</td>
              <td>PDR</td>
              <td>Responsabile</td>
              <td>Indirizzo Resp.</td>
              <td>Comune Resp.</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(implant, index) in implants.new" :key="index">
              <td>{{ implant.code }}</td>
              <td>{{ implant.plate }}</td>
              <td>{{ implant.pod }}</td>
              <td>{{ implant.pdr }}</td>
              <td>{{ implant.clientFull }}</td>
              <td>{{ implant.clientAddress }}</td>
              <td>{{ implant.clientCity }}</td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="column is-12">
        <div class="is-flex is-align-items-center">
          <b>RCEE diverse: {{ implants.rcee ? implants.rcee.length : 0 }} (Mese diverso: {{ implants.rcee ? implants.rcee.filter(r => !r.isSameMonth).length : 0 }})</b>
          <button class="button is-dark ml-2" @click="showRcee = !showRcee"><font-awesome-icon :icon="showRcee ? 'eye-slash' : 'eye'" /> {{ showRcee ? 'Chiudi' : 'Apri' }}</button>
          <button class="button is-warning ml-2" @click="hideRceeSimilar = !hideRceeSimilar"><font-awesome-icon :icon="hideRceeSimilar ? 'fa-regular fa-square-check' : 'fa-regular fa-square'" /> Nascondi stesso mese</button>
        </div>
        <table v-if="implants.rcee && implants.rcee.length" class="table is-fullwidth" v-show="showRcee">
          <thead>
            <tr>
              <td>Data sistema</td>
              <td>Data file</td>
              <td>Impianto</td>
              <td>Luogo</td>
              <td>Cliente</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rcee, index) in implants.rcee" :key="index" v-show="!rcee.isSameMonth || !hideRceeSimilar" :class="{ 'has-background-warning-light': rcee.isSameMonth }">
              <td>
                {{ rcee.foundExpire ? new Date(rcee.foundExpire).toDisplay() : '' }}
              </td>
              <td>
                {{ new Date(rcee.newExpire).toDisplay() }}
              </td>
              <td>
                <router-link v-if="rcee.implant" :to="'/impianti/' + rcee.implant._id">
                  {{$implantName(rcee.implant) ? $implantName(rcee.implant) : '----'}}
                </router-link>
              </td>
              <td>
                <router-link v-if="rcee.client" :to="'/clienti/' + rcee.client._id">
                  <ClientHeading :client="rcee.client" />
                </router-link>
              </td>
              <td>
                <router-link v-if="rcee.place" :to="'/luoghi/' + rcee.place._id">
                  <div>{{rcee.place.city}}</div>
                  <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(rcee.place)">{{$fulladdress(rcee.place)}}</small></div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="column is-12">
        <div class="is-flex is-align-items-center">
          <b>RCEE ultima manutenzione diverse: {{ implants.rcee_log ? implants.rcee_log.length : 0 }} (Mese diverso: {{ implants.rcee_log ? implants.rcee_log.filter(r => !r.isSameMonth).length : 0 }})</b>
          <button class="button is-dark ml-2" @click="showRceeLog = !showRceeLog"><font-awesome-icon :icon="showRceeLog ? 'eye-slash' : 'eye'" /> {{ showRceeLog ? 'Chiudi' : 'Apri' }}</button>
          <button class="button is-warning ml-2" @click="hideRceeLogSimilar = !hideRceeLogSimilar"><font-awesome-icon :icon="hideRceeLogSimilar ? 'fa-regular fa-square-check' : 'fa-regular fa-square'" /> Nascondi stesso mese</button>
        </div>
        <table v-if="implants.rcee_log && implants.rcee_log.length" class="table is-fullwidth" v-show="showRceeLog">
          <thead>
            <tr>
              <td>Data sistema</td>
              <td>Data file</td>
              <td>Impianto</td>
              <td>Luogo</td>
              <td>Cliente</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rcee_log, index) in implants.rcee_log" :key="index" v-show="!rcee_log.isSameMonth || !hideRceeLogSimilar" :class="{ 'has-background-warning-light': rcee_log.isSameMonth }">
              <td>
                {{ rcee_log.foundExpire ? new Date(rcee_log.foundExpire).toDisplay() : '' }}
              </td>
              <td>
                {{ new Date(rcee_log.newExpire).toDisplay() }}
              </td>
              <td>
                <router-link v-if="rcee_log.implant" :to="'/impianti/' + rcee_log.implant._id">
                  {{$implantName(rcee_log.implant) ? $implantName(rcee_log.implant) : '----'}}
                </router-link>
              </td>
              <td>
                <router-link v-if="rcee_log.client" :to="'/clienti/' + rcee_log.client._id">
                  <ClientHeading :client="rcee_log.client" />
                </router-link>
              </td>
              <td>
                <router-link v-if="rcee_log.place" :to="'/luoghi/' + rcee_log.place._id">
                  <div>{{rcee_log.place.city}}</div>
                  <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(rcee_log.place)">{{$fulladdress(rcee_log.place)}}</small></div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="column is-12">
        <div class="is-flex is-align-items-center">
          <b>Man. ordinaria diverse: {{ implants.man ? implants.man.length : 0 }} (Mese diverso: {{ implants.man ? implants.man.filter(r => !r.isSameMonth).length : 0 }})</b>
          <button class="button is-dark ml-2" @click="showMan = !showMan"><font-awesome-icon :icon="showRceeLog ? 'eye-slash' : 'eye'" /> {{ showRceeLog ? 'Chiudi' : 'Apri' }}</button>
          <button class="button is-warning ml-2" @click="hideManSimilar = !hideManSimilar"><font-awesome-icon :icon="hideManSimilar ? 'fa-regular fa-square-check' : 'fa-regular fa-square'" /> Nascondi stesso mese</button>
        </div>
        <table v-if="implants.man && implants.man.length" class="table is-fullwidth" v-show="showMan">
          <thead>
            <tr>
              <td>Data sistema</td>
              <td>Data file</td>
              <td>Impianto</td>
              <td>Luogo</td>
              <td>Cliente</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(man, index) in implants.man" :key="index" v-show="!man.isSameMonth || !hideManSimilar" :class="{ 'has-background-warning-light': man.isSameMonth }">
              <td>
                {{ man.foundExpire ? new Date(man.foundExpire).toDisplay() : '' }}
              </td>
              <td>
                {{ new Date(man.newExpire).toDisplay() }}
              </td>
              <td>
                <router-link v-if="man.implant" :to="'/impianti/' + man.implant._id">
                  {{$implantName(man.implant) ? $implantName(man.implant) : '----'}}
                </router-link>
              </td>
              <td>
                <router-link v-if="man.client" :to="'/clienti/' + man.client._id">
                  <ClientHeading :client="man.client" />
                </router-link>
              </td>
              <td>
                <router-link v-if="man.place" :to="'/luoghi/' + man.place._id">
                  <div>{{man.place.city}}</div>
                  <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(man.place)">{{$fulladdress(man.place)}}</small></div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      disabledSave: false,

      implants: {
        found: 0,
        new: [],
        rcee: [],
        rcee_log: [],
        man: []
      },

      showNew: false,
      showRcee: false,
      showRceeLog: false,
      showMan: false,

      hideRceeSimilar: false,
      hideRceeLogSimilar: false,
      hideManSimilar: false,

      importLabel: 'Seleziona un file'
    }
  },

  computed: {

  },

  methods: {
    startUpload() {
      const self = this

      self.disabledSave = true
      self.implants = {}

      const files = this.$refs.inputFile.files
      
      let formData = new FormData()

      formData.append('file', files[0])

      self.$http.post('/import/curmit', formData)
        .then(function (response) {
          const data = response.data

          self.implants = {
            found: data.foundImplants,
            new: data.newImplants,
            rcee: data.diffRcee,
            rcee_log: data.diffRceeLog,
            man: data.diffMan
          }
          
          self.disabledSave = false
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          self.disabledSave = false
        })
    },

    updateLabel() {
      if (this.$refs.inputFile && this.$refs.inputFile.files) {
        this.importLabel = this.$refs.inputFile.files[0].name
      } else {
        this.importLabel = 'Seleziona un file'
      }
    }
  },

  mounted() {
    
  }
}
</script>